<template>
  <t-vdxb-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
    <div class="t-vdxb-application-invite-user-upload__instruction">
      <a-vdxb-heading tag="h4">PDFファイルアップロード</a-vdxb-heading>
      <ul class="a-caption-list">
        <li class="t-vdxb-application-invite-user-upload-houjin__note">
          有効期限の記載がない書類は6か月以内に作成されたものをアップロードしてください
        </li>
      </ul>
    </div>
    <form v-if="show_form" class="t-vdxb-application-invite-user-upload__form" @submit.prevent="handleSubmitForm">
      <div class="t-vdxb-application-invite-user-upload__fields">
        <div class="m-form-input">
          <label class="m-form-input__label">登記事項証明書（登記簿謄本）(PDF、最大10枚)</label>
        </div>
        <template v-for="(document, index) in formData.documents" :key="index">
          <m-form-input>
            <div class="t-vdxb-application-invite-user-upload__field-uploads">
              <div
                v-for="(image, imageIndex) in document.images"
                :id="'registrationCertificate_' + index + '_' + imageIndex"
                :key="imageIndex"
                class="t-vdxb-application-invite-user-upload__field-uploads-col"
              >
                <!-- <a-vdxb-upload-field
                  v-model="image.file"
                  label="ファイルをドラッグ＆ドロップするかパソコンから画像を貼り付けしてください。"
                  accept="image/*"
                  @change="handleUploadFileChange(index, imageIndex, image.file)"
                /> -->
                <a-vdxb-upload-field
                  v-model="image.file"
                  label="PDFファイルをアップロードしてください。"
                  accept="application/pdf"
                  @change="handleUploadFileChange(index, imageIndex, image.file)"
                />
              </div>
            </div>
          </m-form-input>
        </template>
      </div>
      <div class="t-vdxb-application-invite-user-upload__fields">
        <template v-for="(document, index) in formData2.documents" :key="index">
          <div class="m-form-input"></div>
          <m-form-input>
            <label class="m-form-input__label">委任状<span class="m-form-input__type">任意</span></label>
            <div class="t-vdxb-application-invite-user-upload__field-uploads">
              <div
                v-for="(image, imageIndex) in document.images"
                :id="'letterOfCommission' + imageIndex"
                :key="imageIndex"
                class="t-vdxb-application-invite-user-upload__field-uploads-col"
              >
                <!-- <a-upload-field
                  v-model="image.file"
                  label="ファイルをドラッグ＆ドロップするかパソコンから画像を貼り付けしてください。"
                  accept="image/*"
                  @change="handleUploadFileChange(index, imageIndex, image.file)"
                /> -->
                <a-vdxb-upload-field
                  v-model="image.file"
                  label="PDFファイルをアップロードしてください。"
                  accept="application/pdf"
                  @change="handleUploadFileChange2(index, imageIndex, image.file)"
                />
              </div>
            </div>
            <div class="m-form-input__note">
              <ul class="a-caption-list">
                <li class="t-vdxb-application-invite-user-upload-houjin__note">
                  申し込み者が登記事項証明書上の取締役の場合は不要です
                </li>
                <li class="t-vdxb-application-invite-user-upload__note">
                  様式例は<a
                    href="https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/for_business_hansyuhou.pdf#page=2&toolbar=0"
                    target="_blank"
                    title="別ウインドウにてPDF文書が表示されます。"
                    class="a-vdxb-button a-vdxb-button--text a-vdxb-button--color-primary a-vdxb-button--medium a-vdxb-button--link"
                    ><!--v-if-->こちら(573KB)</a
                  ><img src="/public/PDF_32.png" />
                </li>
              </ul>
            </div>
          </m-form-input>
        </template>
      </div>
      <!--
      <div class="t-vdxb-application-invite-user-upload__fields">
        <template v-for="(document, index) in formData.documents" :key="index">
          <m-form-input :label="'画像データ' + (index + 1)">
            <a-vdxb-select-field
              v-model="document.type"
              placeholder="書類の種類を選択してください"
              :options="documentTypeOptions"
            />
            <div class="t-vdxb-application-invite-user-upload__field-uploads">
              <div
                v-for="(image, imageIndex) in document.images"
                :key="imageIndex"
                class="t-vdxb-application-invite-user-upload__field-uploads-col"
              >
                <a-vdxb-upload-field
                  v-model="image.file"
                  label="ファイルをドラッグ＆ドロップするかパソコンから画像を貼り付けしてください。"
                  accept="image/*"
                  @change="handleUploadFileChange(index, imageIndex, image.file)"
                />
              </div>
            </div>
          </m-form-input>
        </template>
      </div>
      -->
      <div class="t-vdxb-application-invite-user-upload__buttons">
        <m-button-container>
          <!-- <a-button variant="block" submit="submit" color="primary">次へ</a-vdxb-button> -->
          <a-vdxb-button id="next" variant="block" submit="submit" color="primary" :disabled="!agree"
            >次へ</a-vdxb-button
          >
          <a-vdxb-button id="back" color="primary" @click="handleCancelClick">戻る</a-vdxb-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-vdxb-modal
        v-model:visible="resultModalVisible"
        class="o-vdxb-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-vdxb-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-vdxb-text>
        <template #footer>
          <a-vdxb-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-vdxb-modal>
    </teleport>
  </t-vdxb-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TVdxbDefaultEntrySidebar from '@/components/templates/vdxb-default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
// import AVdxbSelectField from '@/components/atoms/vdxb-select-field';
import AVdxbButton from '@/components/atoms/vdxb-button';
import MButtonContainer from '@/components/molecules/button-container';
import AVdxbUploadField from '@/components/atoms/vdxb-upload-field';
import AVdxbHeading from '@/components/atoms/vdxb-heading';
import AVdxbText from '@/components/atoms/vdxb-text';
import { cloneDeep } from 'lodash';
import OVdxbModal from '@/components/organisms/vdxb-modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { utils } from '@/common/utils.js';
import Loading from 'vue-loading-overlay';

export default {
  name: 't-vdxb-application-invite-user-upload-houjin',
  components: {
    TVdxbDefaultEntrySidebar,
    MFormInput,
    // ASelectField,
    AVdxbButton,
    MButtonContainer,
    AVdxbUploadField,
    AVdxbHeading,
    AVdxbText,
    OVdxbModal,
    Loading,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '契約情報の入力(法人)' },
          { label: '法人の確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 4,
        heading: '法人の確認書類',
        subHeading: 'Step 4',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      // documentTypeOptions: IDENTIFICATION_OPTIONS,
      formData: {
        documents: [
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
      },
      formData2: {
        documents: [
          {
            type: 'inninjou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
      },
      tmpCompanyID: '',
      tmpDate: '',
      dirname: '',
      agree: false,
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      isLoading: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user-upload-houjin');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    document.title = '法人の確認書類 | COTOHA Voice DX Basic';

    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: '/vdxbsignup' });
      return; // #2314
    }

    try {
      this.tmpCompanyID = this.tmpUUID;
      this.tmpDate = this.tmpYMD;
      if (!this.tmpCompanyID || !this.tmpDate) {
        throw new Error('Invalid data.');
      }
      this.dirname = this.tmpCompanyID;

      const result = await this.getHistoryDoc(this.tmpCompanyID, this.tmpDate);

      if (!result) {
        throw new Error('Invalid data.');
      }
    } catch (error) {
      console.log(error);
      this.showErrorModal(messageContent.requireTry('情報取得'));
    }

    this.show_form = true;
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    async handleSubmitForm(e) {
      // e.preventDefault();
      const payload = cloneDeep(this.formData);
      this.handleFormSubmit(payload);

      try {
        if (
          !this.formData.documents[0].images[0].binary &&
          !this.formData.documents[0].images[1].binary &&
          !this.formData.documents[1].images[0].binary &&
          !this.formData.documents[1].images[1].binary &&
          !this.formData.documents[2].images[0].binary &&
          !this.formData.documents[2].images[1].binary &&
          !this.formData.documents[3].images[0].binary &&
          !this.formData.documents[3].images[1].binary &&
          !this.formData.documents[4].images[0].binary &&
          !this.formData.documents[4].images[1].binary
        ) {
          this.showErrorModal(messageContent.requireUploadFile('登記事項証明書（登記簿謄本）'));
          return;
        }

        // ファイルサイズチェック
        for (let i = 0; i < 5; i++) {
          for (let j = 0; j < 2; j++) {
            if (
              this.formData.documents[i].images[j].size !== null &&
              this.formData.documents[i].images[j].size > 10485760
            ) {
              this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
              return;
            }

            if (this.chkFilenameLengthOver(i, j) === true) {
              this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
              return;
            }
          }
        }

        if (
          this.formData2.documents[0].images[0].size !== null &&
          this.formData2.documents[0].images[0].size > 10485760
        ) {
          this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
          return;
        }

        if (this.formData2.documents[0].images[0].filename !== null) {
          if (this.formData2.documents[0].images[0].filename.length > 100) {
            this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
            return;
          }
        }

        // delete old upload file
        const result = await this.getCertificateDoc(this.tmpCompanyID, this.tmpDate);
        await this.deleteImage(result.copyOfCompanyRegisterURL1);
        await this.deleteImage(result.copyOfCompanyRegisterURL2);
        await this.deleteImage(result.copyOfCompanyRegisterURL3);
        await this.deleteImage(result.copyOfCompanyRegisterURL4);
        await this.deleteImage(result.copyOfCompanyRegisterURL5);
        await this.deleteImage(result.copyOfCompanyRegisterURL6);
        await this.deleteImage(result.copyOfCompanyRegisterURL7);
        await this.deleteImage(result.copyOfCompanyRegisterURL8);
        await this.deleteImage(result.copyOfCompanyRegisterURL9);
        await this.deleteImage(result.copyOfCompanyRegisterURL10);
        await this.deleteImage(result.letterOfAttorneyURL);

        const url = new Map();
        // #3212
        this.isLoading = true;

        // upload touki
        if ((await this.chkPdf(url)) === false) {
          this.isLoading = false;
          this.showErrorModal(messageContent.requireChoice('PDFファイル'));
          return;
        }

        // upload inninjou
        if (this.formData2.documents[0].images[0].binary) {
          const extList = this.formData2.documents[0].images[0].filename.split('.');
          const ext = extList[extList.length - 1].toLowerCase();

          if (ext !== 'pdf') {
            this.isLoading = false;
            this.showErrorModal(messageContent.requireChoice('PDFファイル'));
            return;
          }

          const filename = 'LetterOfAttorney';
          const result = await this.uploadImage(
            this.dirname + '/' + filename + '.pdf',
            this.formData2.documents[0].images[0].binary
          );

          if (result === 'error') {
            this.isLoading = false;
            this.showErrorModal(messageContent.requireChoice('PDFファイル'));
            return;
          }

          url.set(filename, result);
        }

        const ret = await this.setCertificateDoc(
          this.tmpCompanyID,
          this.tmpDate,
          url.get('Company1'),
          url.get('Company2'),
          url.get('Company3'),
          url.get('Company4'),
          url.get('Company5'),
          url.get('Company6'),
          url.get('Company7'),
          url.get('Company8'),
          url.get('Company9'),
          url.get('Company10'),
          url.get('LetterOfAttorney')
        );

        if (ret === 'error') {
          throw new Error('/signup/sethoujinuploadfileinfo response was not ok.');
        }

        this.isLoading = false;

        this.$router.push({ name: 'VdxbSignupInvoice' });
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.showErrorModal(messageContent.requireTry('ファイルのアップロード'));
      }
    },
    handleCancelClick() {
      this.$router.push({ name: 'VdxbSignupFormH' });
    },
    handleUploadFileChange(documentIndex, imageIndex, file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          vm.formData.documents[documentIndex].images[imageIndex].binary = content;
        },
        false
      );

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        vm.formData.documents[documentIndex].images[imageIndex].filename = file[0].name;
        vm.formData.documents[documentIndex].images[imageIndex].size = file[0].size;
        vm.agree = true;
      } else {
        // clear file content
        vm.formData.documents[documentIndex].images[imageIndex].file = null;
        vm.formData.documents[documentIndex].images[imageIndex].filename = null;
        vm.formData.documents[documentIndex].images[imageIndex].binary = null;
        vm.formData.documents[documentIndex].images[imageIndex].size = null;

        if (
          !this.formData.documents[0].images[0].binary &&
          !this.formData.documents[0].images[1].binary &&
          !this.formData.documents[1].images[0].binary &&
          !this.formData.documents[1].images[1].binary &&
          !this.formData.documents[2].images[0].binary &&
          !this.formData.documents[2].images[1].binary &&
          !this.formData.documents[3].images[0].binary &&
          !this.formData.documents[3].images[1].binary &&
          !this.formData.documents[4].images[0].binary &&
          !this.formData.documents[4].images[1].binary
        ) {
          vm.agree = false;
        }
      }
    },
    handleUploadFileChange2(documentIndex, imageIndex, file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          vm.formData2.documents[documentIndex].images[imageIndex].binary = content;
        },
        false
      );

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        vm.formData2.documents[documentIndex].images[imageIndex].filename = file[0].name;
        vm.formData2.documents[documentIndex].images[imageIndex].size = file[0].size;
      } else {
        // clear file content
        vm.formData2.documents[documentIndex].images[imageIndex].file = null;
        vm.formData2.documents[documentIndex].images[imageIndex].filename = null;
        vm.formData2.documents[documentIndex].images[imageIndex].binary = null;
        vm.formData2.documents[documentIndex].images[imageIndex].size = null;
      }
    },
    uploadImage(path, binary) {
      const format = this.getFileFormat(binary);

      if (format === 'unknown') {
        return 'error';
      }

      return this.postRequest('/signup/uploaddocument', {
        path: path,
        binary: binary,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/uploaddocument response was not ok.');
        }
        return e.result;
      });
    },
    deleteImage(path) {
      if (!path) {
        return false;
      }
      return this.postRequest('/signup/deletedocument', {
        path: path,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/deletedocument response was not ok.');
        }
        return e.result;
      });
    },
    setCertificateDoc(
      tmpCompanyID,
      date,
      copyOfCompanyRegisterURL1,
      copyOfCompanyRegisterURL2,
      copyOfCompanyRegisterURL3,
      copyOfCompanyRegisterURL4,
      copyOfCompanyRegisterURL5,
      copyOfCompanyRegisterURL6,
      copyOfCompanyRegisterURL7,
      copyOfCompanyRegisterURL8,
      copyOfCompanyRegisterURL9,
      copyOfCompanyRegisterURL10,
      letterOfAttorneyURL
    ) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        copyOfCompanyRegisterURL1: copyOfCompanyRegisterURL1,
        copyOfCompanyRegisterURL2: copyOfCompanyRegisterURL2,
        copyOfCompanyRegisterURL3: copyOfCompanyRegisterURL3,
        copyOfCompanyRegisterURL4: copyOfCompanyRegisterURL4,
        copyOfCompanyRegisterURL5: copyOfCompanyRegisterURL5,
        copyOfCompanyRegisterURL6: copyOfCompanyRegisterURL6,
        copyOfCompanyRegisterURL7: copyOfCompanyRegisterURL7,
        copyOfCompanyRegisterURL8: copyOfCompanyRegisterURL8,
        copyOfCompanyRegisterURL9: copyOfCompanyRegisterURL9,
        copyOfCompanyRegisterURL10: copyOfCompanyRegisterURL10,
        letterOfAttorneyURL: letterOfAttorneyURL,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/sethoujinuploadfileinfo', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/sethoujinuploadfileinfo response was not ok.');
            }

            return e.result;
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          return 'error';
        });
    },
    getCertificateDoc(tmpCompanyID, date) {
      return this.postRequest('/signup/getcertificatedoc', {
        tmpCompanyID: tmpCompanyID,
        date: date,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/getcertificatedoc response was not ok.');
        }
        return e.result;
      });
    },
    getHistoryDoc(tmpCompanyID, date) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/gethistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/gethistorydoc response was not ok.');
            }
            return e.result;
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    getFileFormat(binary) {
      const string_of_binary = atob(binary);
      const ary = [];
      let header = '';

      for (let i = 0; i < 5; i++) {
        ary[i] = string_of_binary.charCodeAt(i);
        header += ary[i].toString(16);
      }

      switch (true) {
        case /^255044462d/.test(header):
          return 'application/pdf';
        default:
          return 'unknown';
      }
    },
    chkFilenameLengthOver(i, j) {
      if (this.formData.documents[i].images[j].filename !== null) {
        if (this.formData.documents[i].images[j].filename.length > 100) {
          return true;
        }
      }
      return false;
    },
    chkPdf: async function (url) {
      let count = 1;
      for (let i = 0; i < 5; i++) {
        for (let j = 0; j < 2; j++) {
          if (this.formData.documents[i].images[j].binary) {
            const extList = this.formData.documents[i].images[j].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'pdf') {
              return false;
            }

            const filename = 'Company' + count;
            const result = await this.uploadImage(
              this.dirname + '/' + filename + '.pdf',
              this.formData.documents[i].images[j].binary
            );

            if (result === 'error') {
              return false;
            }

            url.set(filename, result);
            count++;
          }
        }
      }
      return true;
    },
  },
};
</script>
